import type { Account, PlannerRole } from '@/types/app'
import { hasAllAuthorities } from '@/entityHandlers/checkAuthorities'

const hasFullControlBranch = (account: Account): boolean =>
  hasAllAuthorities(account.authorities)([
    'view/branch/report',
    'view/branch/rooms',
    'edit/branch',
  ])

const hasFullControllCorporation = (account: Account): boolean =>
  hasAllAuthorities(account.authorities)([
    'view/corporation/report',
    'view/corporation/rooms',
    'edit/corporation',
  ])

export const getPlannerRole = (account: Account): PlannerRole => {
  if (!hasFullControlBranch(account)) {
    return 'staff'
  }

  return hasFullControllCorporation(account)
    ? 'corporate_admin'
    : 'branch_manager'
}
